var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLubavBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 862,
    height: 862,
    viewBox: "0 0 862 862",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 431,
    r: 431,
    fill: "#BDE3FF",
    fillOpacity: 0.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188 201H348V496.668H512.768C512.768 540.708 475.947 576.409 430.527 576.409C385.056 576.409 348.235 540.708 348.235 496.668H188C188 626.528 296.591 731.82 430.524 731.82C564.457 731.82 673 626.528 673 496.668H512.768V496.668H348V496.668H188Z",
    fill: "#367FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384.248 489.32C384.248 514.864 404.956 535.572 430.5 535.572C456.044 535.572 476.752 514.864 476.752 489.32C476.752 463.776 456.044 443.068 430.5 443.068C404.956 443.068 384.248 463.776 384.248 489.32Z",
    fill: "#FF5B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLubavBubble);
export default __webpack_public_path__ + "static/media/lubav-bubble.33fcad50808bada25920f4de99413a36.svg";
export { ForwardRef as ReactComponent };